import { useEffect, useRef, useState } from 'react';
import { Modal, Stack } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SimpleButton } from '../../../../components/buttons/SimpleButton';
import { useCartContext } from '../../../../context/CartContext';
import { useGetLocationQuery } from '../../../../services/endpoints/places/location';
import '../Checkout.css';
import { StepProps } from '../OrderCheckout';
import { EnrollmentComplete } from './components/EnrollmentComplete';
import { UpdateChild } from './components/UpdateChild';

export const OrderComplete = ({ values }: StepProps) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const courseIds_qs = searchParams.get('course_ids');
  const complete_qs = searchParams.get('complete');
  const navigate = useNavigate();
  const { data } = useGetLocationQuery(values.location.id);
  const [showModal, setShowModal] = useState(false);
  const { removeCourses } = useCartContext();
  const renderAfterCalled = useRef(false);

  // Build one synthetic order per unique child, carrying just one registration each.
  // The modal is about updating child info, so we only need each child once.
  const uniqueRegistrationsByChild = Array.from(
      new Map(
          values.orders
              .flatMap((o) => o.registrations)
              .map((r) => [r.child.id, r])
      ).values()
  );
  const ordersForModal = uniqueRegistrationsByChild.map((r) => ({
    ...values.orders[0],
    registrations: [r]
  }));

  const updateCart = async () => {
    if (!renderAfterCalled.current) {
      renderAfterCalled.current = true;
      if (courseIds_qs) {
        let courseIds = courseIds_qs?.split(',').map((id) => parseInt(id)) ?? [];
        removeCourses(courseIds);
        if (complete_qs === String(values.location.id)) {
          setShowModal(true);
        }
      }
    }
  };

  useEffect(() => {
    updateCart();
  }, []);

  return (
      <>
        <Stack className="text-info order-complete-page">
          <h2>
            Thank you. <em>You're Awesome Sauce!</em>
          </h2>
          <span>
          For any questions, please contact us at {data?.location?.manager?.email ?? 'N/A'}
        </span>
          <span>Please review your enrollment details below and LETTUCE get cooking!</span>
          <hr />
          <div className="label">Enrollment Details</div>
          <EnrollmentComplete orders={values.orders} />
        </Stack>
        <Modal
            centered
            backdrop="static"
            show={showModal}
            onHide={() => setShowModal(false)}
            dialogClassName="checkout-modal"
        >
          <Modal.Body className="checkout-modal-body p-2">
            <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
              <span className="fw-bold text-info h4 mb-0">Order Placed</span>
              <button
                  type="button"
                  className="btn-close flex-shrink-0"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
              />
            </div>
            <h3 className="h5 mb-2">Update your child's information!</h3>
            <p className="text-muted mb-3">Don't forget to update your child's information</p>
            {ordersForModal.map((o) => (
                <UpdateChild
                    order={o}
                    key={o.registrations[0].child.id}
                />
            ))}
            <div className="checkout-modal-actions mt-3">
              <SimpleButton
                  type="button"
                  variant="outline-primary"
                  width="100%"
                  className="text-wrap"
                  onClick={() => navigate('/user/profile')}
              >
                Update Now
              </SimpleButton>
              <SimpleButton
                  type="button"
                  variant="primary"
                  width="100%"
                  className="text-wrap"
                  onClick={() => setShowModal(false)}
              >
                This Looks Good!
              </SimpleButton>
            </div>
          </Modal.Body>
        </Modal>
      </>
  );
};
